import { render, staticRenderFns } from "./SubDetailPage.vue?vue&type=template&id=8078e482&scoped=true"
import script from "./SubDetailPage.vue?vue&type=script&lang=js"
export * from "./SubDetailPage.vue?vue&type=script&lang=js"
import style0 from "./SubDetailPage.vue?vue&type=style&index=0&id=8078e482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8078e482",
  null
  
)

export default component.exports